import { jsx } from "panel";
import { LineChartEl } from "common/charts/visualization/line-chart";
import { DisplayAnalysisType } from "common/charts/visualization/line-chart/enums";
import { SegmentLegendHeaderEl } from "common/charts/misc/segment-legend-header";
import { NoDataHero } from "common/widgets/warning-hero/presets";
import { WarningHeroReportName } from "common/widgets/warning-hero/constants";
import { ContextMenuEl } from "common/widgets/context-menu";
export function template() {
  if (!this.helpers.hasResults()) {
    return /* @__PURE__ */ jsx("div", {
      sel: ".retention-line-chart"
    }, /* @__PURE__ */ jsx(NoDataHero, {
      reportName: WarningHeroReportName.Retention
    }));
  }
  return /* @__PURE__ */ jsx("div", {
    sel: ".root"
  }, /* @__PURE__ */ jsx(SegmentLegendHeaderEl, {
    sel: ".segment-legend-header"
  }), /* @__PURE__ */ jsx(LineChartEl, {
    sel: ".line-chart",
    attrs: {
      "chart-width": null,
      "display-analysis-type": DisplayAnalysisType.Linear,
      "incomplete-to-date": this.helpers.isEndDateIncomplete(),
      timezone: this.helpers.getProjectTimezone(),
      "utc-offset": this.helpers.getUtcOffset(),
      "time-unit": this.helpers.getTimeUnit(),
      "zoom-type": `x`,
      "show-annotations": this.attr(`show-annotations`),
      "y-axis-options": this.helpers.getYAxisOptions()
    },
    props: this.helpers.getLineChartProps()
  }), this.state.popoverSelection && /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(ContextMenuEl, {
    attrs: {
      "menu-items": this.popoverCallback(this.state.popoverSelection.series.options.name),
      "relative-positioning": true,
      open: true,
      position: { left: 0, top: 0 }
    },
    style: this.state.popoverStyles,
    on: {
      action: (ev) => this.handlePopoverAction(ev),
      close: () => this.handlePopoverClose()
    }
  })));
}
